import styled from 'particles/themes/styled'

export const AiReviewContainer = styled.div`
    flex-direction: column;
    margin: 12px 0;
    .review-status {
        margin-top: 12px;
        border-radius: 12px;
        border-style: dashed;
        border-width: 1px;
        padding: 8px 12px;
        border-color: ${({ theme }) => theme.colors.border.neutralAction};
        gap: ${({ theme }) => theme.spacing[100]};
    }
    .icon-block {
        gap: ${({ theme }) => theme.spacing[100]};
        display: flex;
    }
    .review-block {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[200]};
        justify-content: center;
    }
    .review-title-block {
        gap: ${({ theme }) => theme.spacing[100]};
        display: flex;
    }
    .edit-reason {
        display: flex;
        gap: ${({ theme }) => theme.spacing[100]};
    }
`
